import  {useEffect, useState} from 'react'
import {ChartsWidget9} from '../../dashboard/DashboardChart'
import {fetchData, toasterrormsg} from '../../../../reusable'
import {ToastContainer} from 'react-toastify'
import {isEmptyArray} from 'formik'
import {Tr} from '../../../../_metronic/i18n/Tr'

const ViewVendorWiseEarning = () => {
  let t = Tr()

  const [chartData, setChartData] = useState<{name: string; data: number[]}[]>([])

  const [categories, setCategories] = useState<string[]>([])
  const [totalRevenue, setTotalRevenue] = useState('')
  const [data, setData] = useState<any>(null)
  const [length, setLength] = useState('')

  const getData = (data: any) => {
    setData(data)
  }

  const fetchRevenueData = async () => {
    if (data?.selectedVendorMonth && !data?.selectedVendorYear) {
      toasterrormsg('Please Select Year')
      return
    }
    if (data && !data.vendorId && data.vendorId !== 0) {
      toasterrormsg('Please Select Vendor')
      return
    }

    // Dynamically build param object
    let param: any = {}

    if (data) {
      // Add categoryId if present and not empty/undefined
      if (data.categoryId !== undefined && data.categoryId !== null && data.categoryId !== '') {
        param.categoryId = data.categoryId
      }

      // Add vendorId if present (including 0)
      if (data.vendorId !== undefined && data.vendorId !== null) {
        param.vendorId = data.vendorId
      }

      // Add propertyId if present (including 0)
      if (data.propertyId !== undefined && data.propertyId !== null) {
        param.propertyId = data.propertyId
      }

      // Add date range if both dates are present and not empty
      if (data.startDate && data.endDate && data.startDate !== '' && data.endDate !== '') {
        param.fromDate = data.startDate
        param.toDate = data.endDate
      }
    }
    const res = await fetchData('admin/revenuedetail', param)

    if (res.status == '200') {
      if (data) {
        const vendorData = res.data.category[0].vendorWise

        setLength(vendorData.length)
        let totalRevenue = []
                
        if (data.vendorId == '0') {
          setTotalRevenue(res.data.category[0].totalAmount)
          totalRevenue = [res.data.category[0].totalAmount]
        } else {
          setTotalRevenue(res.data.category[0].vendorWise[0].totalAmount)
          totalRevenue = [res.data.category[0].vendorWise[0].totalAmount]
        }

        setChartData([{name: t('Vendor Revenue'), data: totalRevenue}])

        setCategories([
          data.propertyId != 0 && data.propertyId != '' && data.propertyId != undefined
            ? data.propertyName
            : data.vendorName != '' && data.vendorName != undefined && data.vendorName != null
            ? data.vendorName
            : '',
        ])
      } else {
        if (!isEmptyArray(res.data.category)) {
          const categoryData = res.data.category

          setLength(categoryData.length)

          const totalRevenue = categoryData.map((item: any) => parseFloat(item.totalAmount))
          setChartData([{name: t('Category Revenue'), data: totalRevenue}])
          setCategories(
            categoryData.map((item: any) =>
              item.categoryId == '1'
                ? t('Accommodation')
                : item.categoryId == '2'
                ? t('Restaurant')
                : item.categoryId == '4'
                ? t('Space Rental')
                : item.categoryId == '5'
                ? t('Tour Package')
                : ''
            )
          )
          setTotalRevenue(res.data.totale.totalAmount != '' ? res.data.totale.totalAmount : 0)
        } else {
          setLength('0')
        }
      }
    } else {
      setLength('0')
    }
  }
  useEffect(() => {
    fetchRevenueData()
    document.title = 'Insayr | View Vendor Wise Earning'
  }, [data])

  return (
    <>
      <ToastContainer />
      <ChartsWidget9
        className='card-xl-stretch mb-5 mb-xl-8 height440px'
        data={chartData}
        categories={categories}
        totalRevenue={totalRevenue}
        sendData={getData}
        length={length}
      />
    </>
  )
}

export default ViewVendorWiseEarning
